import { render } from "./ShopLayout.vue?vue&type=template&id=1731953b"
import script from "./ShopLayout.vue?vue&type=script&lang=js"
export * from "./ShopLayout.vue?vue&type=script&lang=js"

import "./ShopLayout.vue?vue&type=style&index=0&id=1731953b&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__